if (!customElements.get('reviews-rotator')) {
  class ReviewsRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.stage = this.querySelector('[data-stage]');
      this.toggleBtn = this.querySelector('[data-toggle]');
      this.interval = (parseInt(this.dataset.interval, 10) || 7) * 1000;
      this.index = 0;
      this.timer = null;
      this.hover = false;
      this.focusIn = false;
      this.visible = true;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.coarse = window.matchMedia('(pointer: coarse)');
      this.userPaused = this.reduce.matches;

      this.onReduce = () => {
        if (this.reduce.matches) this.userPaused = true;
        this.sync();
      };
      this.onVisibility = () => this.schedule();
      this.reduce.addEventListener('change', this.onReduce);
      document.addEventListener('visibilitychange', this.onVisibility);

      this.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') {
          this.hover = true;
          this.schedule();
        }
      });
      this.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') {
          this.hover = false;
          this.schedule();
        }
      });
      this.addEventListener('focusin', (e) => {
        if (e.target.matches && e.target.matches(':focus-visible')) {
          this.focusIn = true;
          this.schedule();
        }
      });
      this.addEventListener('focusout', () => {
        this.focusIn = false;
        this.schedule();
      });

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.sync();
        });
      }

      let startX = null;
      this.stage.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });
      this.stage.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
      this.stage.addEventListener('click', () => {
        if (this.coarse.matches) {
          this.userPaused = !this.userPaused;
          this.sync();
        }
      });

      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target);
        if (i > -1) this.go(i, false);
        this.userPaused = true;
        this.sync();
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);
      }

      this.go(0, false);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.observer) this.observer.disconnect();
      if (this.reduce) this.reduce.removeEventListener('change', this.onReduce);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    go(i, manual) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.slides.forEach((slide, k) => {
        const active = k === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      this.dots.forEach((dot, k) => {
        if (k === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (manual && this.coarse.matches) this.userPaused = true;
      this.sync();
    }

    sync() {
      const playing = !this.userPaused;
      if (this.toggleBtn) {
        const d = this.toggleBtn.dataset;
        this.toggleBtn.setAttribute('aria-label', playing ? d.labelPause : d.labelPlay);
        this.toggleBtn.setAttribute('data-state', playing ? 'playing' : 'paused');
      }
      if (this.stage) this.stage.setAttribute('aria-live', playing ? 'off' : 'polite');
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      const run = !this.userPaused && !this.hover && !this.focusIn && this.visible && !document.hidden;
      if (run) this.timer = setTimeout(() => this.go(this.index + 1, false), this.interval);
    }
  }
  customElements.define('reviews-rotator', ReviewsRotator);
}